import { faArrowRight, faLocationDot } from '@fortawesome/pro-light-svg-icons';
import { Laboratory } from '@medprev-web-app/api-graphql-client';

import { Link } from '@/components/ui/link/link.component';
import { Icon } from '@/components/ui/icon.component';
import { formatDistance } from '@/utils/formatters/format-distance';
import { googleMapsBaseUrl } from '@/utils/consts/google-maps.consts';
import { formatGoogleMapsAddress } from '@/utils/formatters/format-address';
import { formatPartnerAddress } from '@/utils/formatters/format-partner';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

type LaboratoryAddressProps = {
  laboratory: Laboratory;
};

export function BranchLaboratoryAddress({ laboratory }: LaboratoryAddressProps) {
  const { neighborhood, city, state, addressLine1, addressLine2, zipcode, number } = laboratory || {};

  const formattedAddress = formatGoogleMapsAddress({
    addressLine1: addressLine1 ?? '',
    number: number ?? '',
    addressLine2: addressLine2 ?? '',
    neighborhood: neighborhood ?? '',
    city: city ?? '',
    state: state ?? '',
    zipcode: zipcode ?? '',
  });

  const hasDistance = !!laboratory.distance;

  return (
    <section className="flex items-start gap-2">
      <div className="w-6 h-6 flex items-center justify-center">
        <Icon icon={faLocationDot} className="text-gray-500 w-6 h-6" />
      </div>
      <div className="flex flex-col">
        <p className="text-gray-700 break-words whitespace-pre-line">
          {formatPartnerAddress({
            addressLine1: addressLine1 ?? '',
            number: number ?? '',
            addressLine2: addressLine2 ?? '',
            neighborhood: neighborhood ?? '',
            city: city ?? '',
            state: state ?? '',
            zipcode: zipcode ?? '',
          })}
        </p>
        {hasDistance && <p className="text-gray-500 font-light">{`a ${formatDistance(laboratory.distance || '')}km`}</p>}

        <span className="mt-2">
          <Link
            prefetch={false}
            target="_blank"
            rel="noopener noreferrer"
            href={`${googleMapsBaseUrl}${formattedAddress}`}
            className="inline-flex items-center gap-2 text-green-500 leading-6 font-semibold"
            data-analytics-event={AnalyticsEnum.LABORATORY_PROFILE_CLICK_OPEN_IN_MAP}
          >
            Abrir no mapa
            <Icon icon={faArrowRight} className="w-4 h-4 shrink-0" />
          </Link>
        </span>
      </div>
    </section>
  );
}
